// extracted by mini-css-extract-plugin
module.exports = {"modal":"eO","modalContent":"fO","modalOverlay":"gO","copy":"hO","modalBtnContainer":"iO","btnStay":"jO","disabled":"kO","btnContinue":"lO"};